import {AfterViewInit, Directive, ElementRef, Input, OnInit} from "@angular/core";
import {provinceBasedFieldLabels} from "./province-based-field-labels";

@Directive({selector : '[dp-province-field-label]'})

export class DpProvinceFieldLabel implements OnInit, AfterViewInit {

    private _provinceLabel: string;
    private _provinceCode: string;

    @Input('dp-province-field-label')
    set provinceLabel(fieldCode : string) {
        if(fieldCode) {
            this._provinceLabel = fieldCode;
            this.updateLabel();
        }

    }

    get provinceLabel() : string {
        return this._provinceLabel;
    }

    @Input('label-province-code')
    set provinceCode(fieldCode : string) {
        if(fieldCode) {
            this._provinceCode = fieldCode;
            this.updateLabel();
        }

    }

    get provinceCode() : string {
        return this._provinceCode;
    }


    constructor(private el: ElementRef) {}

    ngOnInit() : void {

    }

    ngAfterViewInit() : void {
        this.updateLabel();
    }

    private updateLabel() {

        if(this.provinceLabel && this.provinceCode  && provinceBasedFieldLabels[this.provinceLabel] && provinceBasedFieldLabels[this.provinceLabel][this.provinceCode]){
            this.el.nativeElement.innerHTML = provinceBasedFieldLabels[this.provinceLabel][this.provinceCode];
        } else if(this.provinceLabel && provinceBasedFieldLabels[this.provinceLabel] && provinceBasedFieldLabels[this.provinceLabel]['DEFAULT']){
            this.el.nativeElement.innerHTML = provinceBasedFieldLabels[this.provinceLabel]['DEFAULT'];
        }
    }

    ngOnDestroy() {}
}
